import {ChangeDetectorRef, Component, OnInit, ViewChild} from "@angular/core";
import {VoucherOrdersService} from "../../services/voucherOrders.service";
import {ActivatedRoute, Router} from "@angular/router";
import {RoleService} from "../../../services/role.service";
import {VoucherOrder} from "../../../dto/voucher-order";
import {Location} from "@angular/common";
import {toDateString, toDateTimeString} from "../../../providers/app-date-adapter";
import {Voucher} from "./../../../dto/voucher";
import {MultiCrudDataSource} from "../../../table-datasouces/multi-crud.datasource";
import {MatTableGeneratorComponent} from "../../../shared/mat-table-generator/mat-table-generator.component";
import {VouchersService} from "../../services/vouchers.service";
import {VoucherOrderStatus} from "./../../../models/enums/voucher-order-status";
import {ConfirmDialogComponent} from "../../../shared/confirm-dialog/confirm-dialog.component";
import {FileHelper} from "../../../helpers/file-helper";
import {InvoicesService} from "../../services/invoices.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {CompanyService} from "../../services/company.service";
import {Company} from "../../../dto/company";
import {environment} from "../../../../environments/environment";
import {ContentRowField} from "../../../shared/content-row/content-row.component";


@Component({
  selector: 'app-voucher-order-view',
  templateUrl: './voucher-order-view.component.html',
  styleUrls: ['./voucher-order-view.component.css']
})
export class VoucherOrderViewComponent implements OnInit {
  private company: Company|null;
  constructor(
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private voucherOrdersService: VoucherOrdersService,
    private invoicesService: InvoicesService,
    private vouchersService: VouchersService,
    public roleService: RoleService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private changeDetectorRefs: ChangeDetectorRef,
    private companyService: CompanyService,

  ) { }

  @ViewChild(MatTableGeneratorComponent, { static: true }) vouchersTable: MatTableGeneratorComponent;

  voucherOrderStatus = VoucherOrderStatus;
  order: VoucherOrder;
  vouchersDataSource: MultiCrudDataSource<Voucher>;
  voucherColumns = [
    { columnDef: 'id', header: 'Id', cell: (row: Voucher) => `${row.id}` },
    { columnDef: 'code', header: 'Code', cell: (row: Voucher) => `${row.code}`, sortable: false },
    { columnDef: 'voucherStatusName', header: 'Status', cell: (row: Voucher) => `${row.voucherStatusName}`, sortable: false  } as ContentRowField<Voucher>,
    { columnDef: 'voucherType', header: 'Type', cell: (row: Voucher) => `${row.voucherTypeName}`, sortable: false  } as ContentRowField<Voucher>,
    { columnDef: 'orderId', header: 'Order', cell: (row: Voucher) => row.order?`${row.order.id}`:null, sortable: false,
      link: (row: Voucher) => `/orders/${row.order && row.order.id}`  } as ContentRowField<Voucher>,

    {
      columnDef: 'link',
      header: 'Invite Link',
      cell: (row: Voucher) => this.getBrandInviteLinkLastPart(row),
      sortable: false,
      link: (row: Voucher) => (row.voucherStatus != 1 ? "" : this.getBrandInviteLink(row)),
      isExternalLink: (row: Voucher) => true,
      copyCellActive: row => true,
      copyCellContent: row => this.getBrandInviteLink(row)
    },


  ] as ContentRowField<Voucher>[];


  getBrandInviteLinkLastPart(row: Voucher) : string {

    if ( this.company )
      return "brand/" + this.company.brandReferralCode + "?vc=" + row.code;
    return "";
  }


  getBrandInviteLink(row: Voucher) : string {
    return environment.frontendBaseUrl + this.getBrandInviteLinkLastPart(row);
  }


  fields = [
    { header: 'Package name', cell: (row: VoucherOrder) => `${row.packageName}` },
    { header: 'Product', cell: (row: VoucherOrder) => `${row.product.name}` },
    { header: 'Company', cell: (row: VoucherOrder) => `${row.product.company.name}` },
    { header: 'Status', cell: (row: VoucherOrder) => `${row.voucherOrderStatusName}` },
    { header: 'Voucher date', cell: (row: VoucherOrder) => `${toDateTimeString(row.generatedDate)}` },
    { header: 'Start date', cell: (row: VoucherOrder) => `${toDateString(row.startDate)}` },
    { header: 'Expiry date', cell: (row: VoucherOrder) => `${toDateString(row.expireDate)}` },
    { header: 'Invoice code', cell: (row: VoucherOrder) => `${row.invoice != null ? row.invoice.code : ''}` },
  ];

  ngOnInit() {

    this.getVoucerOrder();
    const id = parseInt(this.route.snapshot.paramMap.get('id'));
    this.vouchersService.id = id;
    this.vouchersDataSource = new MultiCrudDataSource(this.vouchersService);

  }

  getVoucerOrder() {
    const id = parseInt(this.route.snapshot.paramMap.get('id'));
    this.voucherOrdersService.get(id).subscribe(
      result => {
        this.order = result;

        this.companyService.get(this.order.product.companyId).subscribe(company => {
          this.company = company;
        });

      });
  }

  refreshDataSource() {
    this.vouchersDataSource.loadData();
    this.changeDetectorRefs.detectChanges();
    this.vouchersTable.refreshTable();
  }

  returnBack() {
    this.location.back();
  }
  activateVoucherOrder() {
    this.voucherOrdersService
    .changeStatus( [ this.order.id ], VoucherOrderStatus.Active )
    .subscribe(() => {
      this.getVoucerOrder();
      this.refreshDataSource();
    });
  }

  cancelVoucherOrder() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Delete vouchers',
        text: 'Are you sure want to delete this order?'
      },
      minWidth: 350,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'ok') {
        this.voucherOrdersService
        .changeStatus( [ this.order.id ], VoucherOrderStatus.Canceled )
        .subscribe(() => {
          this.getVoucerOrder();
          this.refreshDataSource();
        });
      }
    });
  }
  deactivateVoucherOrder() {
    this.voucherOrdersService
      .changeStatus( [ this.order.id ], VoucherOrderStatus.Inactive )
      .subscribe(() => {
        this.getVoucerOrder();
        this.refreshDataSource();
      });
  }
  regenerateVoucherOrder() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Regenerate vouchers',
        text: 'Are you sure want to regenerate all unused vouchers from this order?'
      },
      minWidth: 350,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'ok') {
        this.voucherOrdersService.regenerateVouchers( this.order.id)
          .subscribe(() => {
this.vouchersTable.applyFilter();
});
      }
    });
  }
  markAsPaid() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Mark as paid',
        text: 'Are you sure want to mark this voucher order as paid?'
      },
      minWidth: 350,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'ok') {
        this.voucherOrdersService.changeStatus( [ this.order.id ], VoucherOrderStatus.Active ).subscribe(() => {
          this.invoicesService.markAsPaidMany([this.order.invoiceId])
            .subscribe(() => {
 this.getVoucerOrder(); this.refreshDataSource();
});
        });
      }
    });
  }

  isAdmin() {
    return this.roleService.hasRoles(['admin']);
  }

  canManage() {
    return this.roleService.hasRoles(['admin', 'partner']);
  }

  canSee() {
    return this.roleService.hasRoles(['admin', 'partner', 'manager', 'compliance']);
  }

  downloadVouchers() {
    this.voucherOrdersService.downloadVouchers(this.order.id).subscribe(result => {
      FileHelper.saveFile( result );
    });
  }
  downloadAttachment() {
    this.invoicesService.getAttachment( this.order.invoice.id ).subscribe(
        result => {
          FileHelper.saveFile( result );
        },
        err =>
          this.snackBar.open( err.error.message || err.message || err.error || err, null, {
              duration: 5000,
              panelClass: [ 'app-mat-snack-bar' ]
            } )
      );
  }
}
